import React from "react";
import MainLayout from "../Layout/MainLayout";
import Editprofile from "../component/Profile/EditProfile";
import Changepassword from "../component/Profile/ChangePassword";
import Profile from "../component/Profile/Profile";
import Dashboard from "../component/Dashboard/Dashboard";
import UserList from "../component/User/User";
import UserDetails from "../component/User/UserDetails";
import Terms from "../component/Terms&Condition";
import Privacy from "../component/PrivacyPolicy";
import About from "../component/About Us";
import Reports from "../component/Reports/Report";
import VendorList from "../component/Vendor/Vendor";
import SubAdminList from "../component/SubAdmin/subadminlist";
import AddSubadmin from "../component/SubAdmin/Addsubadmin";
import CategoryList from "../component/Category/Categorylist";
import Addcategory from "../component/Category/Addcategory";
import EditCategory from "../component/Category/Editcategory";
import SubcategoryList from "../component/Subcategory/Subcategorylist";
import VrequestList from "../component/Requests/Vendorrequest";
import DrequestList from "../component/Requests/Deliverrequest";
import DeliverypersonList from "../component/Delivery Person/DeliveryPerson";
import OrderList from "../component/Order/Order";
import OrderDetails from "../component/Order/OrderDetails";
import BannerList from "../component/Banner/Bannerlist";
import Addbanner from "../component/Banner/Addbanner";
import Editbanner from "../component/Banner/Editbanner";
import SupportList from "../component/Support/Supportlist";
import FAQSList from "../component/FAQS/FAQS";
import Addfaqs from "../component/FAQS/AddFAQS";
import Editfaqs from "../component/FAQS/EditFAQS";
import SupportDetails from "../component/Support/SupportDetails";
import EditSubcategory from "../component/Subcategory/Editsubcategory";
import PushNotification from "../component/Notification/PushNotification";
import ProtectedRoute from "../Protected Routes/ProtectedRoute";
import Addsubcategory from "../component/Subcategory/Addsubcategory";
import VendorDetails from "../component/Vendor/VendorDetails";
import Feestructure from "../component/Fee structure/Feestructure";
import VoucherList from "../component/Voucher/Voucher";
import AddVoucher from "../component/Voucher/AddVoucher";
import EditVoucher from "../component/Voucher/EditVoucher";
import SMTP from "../component/SMTP/SMTP";
import DriverDetails from "../component/Delivery Person/DriverDetails";
import Settings from "../component/Setting/Settings";
import Products from "../component/Product/Product";
import ProductDetails from "../component/Product/ProductDetails";
import Finance from "../component/Finance/Finance";
import RevenueOverview from "../component/Finance/RevenueOverview";
import StorePayouts from "../component/Finance/StorePayouts";
import DriverPayouts from "../component/Finance/DriverPayouts";
import Transactions from "../component/Finance/Transactions";
import TaxDocuments from "../component/Finance/TaxDocuments";
import { Navigate } from "react-router-dom";
import PromotionsList from "../component/PromotionsMarketing/PromotionsList";
import BannersList from "../component/PromotionsMarketing/BannersList";
import AnnouncementsList from "../component/PromotionsMarketing/AnnouncementsList";
import ReferralSettings from "../component/PromotionsMarketing/ReferralSettings";
import PromotionsMarketing from "../component/PromotionsMarketing/PromotionsMarketing";
import SafetyIncidents from "../component/Support/SafetyIncidents";
import DisputesList from "../component/Support/DisputesList";
import LiveChat from "../component/Support/LiveChat";
import TicketsList from "../component/Support/TicketsList";
import Support from "../component/Support/Support";
import AdminTeam from "../component/AdminTeam/AdminTeam";
import AdminList from "../component/AdminTeam/AdminList";
import AddAdmin from "../component/AdminTeam/AddAdmin";
import RolesPermissions from "../component/AdminTeam/RolesPermissions";
import ActivityLog from "../component/AdminTeam/ActivityLog";
import TwoFactorSettings from "../component/AdminTeam/TwoFactorSettings";
// import ContactList from "../component/Contact Us";
// import ContactDetails from "../component/Contact Us/ContactDetails";

// ==============================|| MAIN ROUTING ||============================== //

const routeConfig = [
  {
    path: "/Dashboard",
    element: <Dashboard />,
    permission: "view_reports",
  },
  {
    path: "/Profile",
    element: <Profile />,
    permission: null, // no permission needed
  },
  {
    path: "/EditProfile",
    element: <Editprofile />,
    permission: null,
  },
  {
    path: "/ChangePassword",
    element: <Changepassword />,
    permission: null,
  },
  {
    path: "/Users_List",
    element: <UserList />,
    permission: "manage_team",
  },
  {
    path: "/User_Details",
    element: <UserDetails />,
    permission: "manage_team",
  },
  {
    path: "/Stores_List",
    element: <VendorList />,
    permission: "manage_stores",
  },
  {
    path: "/Store_Details",
    element: <VendorDetails />,
    permission: "manage_stores",
  },
  {
    path: "/Email_Setting",
    element: <SMTP />,
    permission: "manage_settings",
  },
  {
    path: "/Editors_List",
    element: <SubAdminList />,
    permission: "manage_team",
  },
  {
    path: "/Add_Editors",
    element: <AddSubadmin />,
    permission: "manage_team",
  },
  {
    path: "/Categories_List",
    element: <CategoryList />,
    permission: "manage_catalog",
  },
  {
    path: "/Add_Category",
    element: <Addcategory />,
    permission: "manage_catalog",
  },
  {
    path: "/Edit_Category",
    element: <EditCategory />,
    permission: "manage_catalog",
  },
  {
    path: "/SubCategories_List",
    element: <SubcategoryList />,
    permission: "manage_catalog",
  },
  {
    path: "/Add_Subcategory",
    element: <Addsubcategory />,
    permission: "manage_catalog",
  },
  {
    path: "/Edit_Subcategory",
    element: <EditSubcategory />,
    permission: "manage_catalog",
  },
  {
    path: "/RequestofStores",
    element: <VrequestList />,
    permission: "approve_stores",
  },
  {
    path: "/RequestofDrivers",
    element: <DrequestList />,
    permission: "approve_drivers",
  },
  {
    path: "/Drivers",
    element: <DeliverypersonList />,
    permission: "manage_drivers",
  },
  {
    path: "/Driver_Details",
    element: <DriverDetails />,
    permission: "manage_drivers",
  },
  {
    path: "/Orders",
    element: <OrderList />,
    permission: "manage_orders",
  },
  {
    path: "/Order_Details",
    element: <OrderDetails />,
    permission: "manage_orders",
  },
  {
    path: "/Banners",
    element: <BannerList />,
    permission: "manage_marketing",
  },
  {
    path: "/Add_Banner",
    element: <Addbanner />,
    permission: "manage_marketing",
  },
  {
    path: "/Edit_Banner",
    element: <Editbanner />,
    permission: "manage_marketing",
  },
  {
    path: "/Products",
    element: <Products />,
    permission: "manage_products",
  },
  {
    path: "/product-details",
    element: <ProductDetails />,
    permission: "manage_products",
  },
  // Finance – parent and children all require manage_finance
  {
    path: "/finance",
    element: <Finance />,
    permission: "manage_finance",
    children: [
      {
        index: true,
        element: <Navigate to="revenue" replace />,
        permission: "manage_finance",
      },
      {
        path: "revenue",
        element: <RevenueOverview />,
        permission: "manage_finance",
      },
      {
        path: "store-payouts",
        element: <StorePayouts />,
        permission: "manage_finance",
      },
      {
        path: "driver-payouts",
        element: <DriverPayouts />,
        permission: "manage_finance",
      },
      {
        path: "transactions",
        element: <Transactions />,
        permission: "manage_finance",
      },
      { path: "tax", element: <TaxDocuments />, permission: "manage_finance" },
    ],
  },
  // Promotions – parent and children require manage_marketing
  {
    path: "/promotions",
    element: <PromotionsMarketing />,
    permission: "manage_marketing",
    children: [
      {
        index: true,
        element: <Navigate to="promotions" replace />,
        permission: "manage_marketing",
      },
      {
        path: "promotions",
        element: <PromotionsList />,
        permission: "manage_marketing",
      },
      {
        path: "banners",
        element: <BannersList />,
        permission: "manage_marketing",
      },
      {
        path: "announcements",
        element: <AnnouncementsList />,
        permission: "manage_marketing",
      },
      {
        path: "referrals",
        element: <ReferralSettings />,
        permission: "manage_marketing",
      },
    ],
  },
  // Support – requires manage_support
  {
    path: "/support",
    element: <Support />,
    permission: "manage_support",
    children: [
      {
        index: true,
        element: <Navigate to="tickets" replace />,
        permission: "manage_support",
      },
      {
        path: "tickets",
        element: <TicketsList />,
        permission: "manage_support",
      },
      { path: "chats", element: <LiveChat />, permission: "manage_support" },
      {
        path: "disputes",
        element: <DisputesList />,
        permission: "manage_support",
      },
      {
        path: "safety",
        element: <SafetyIncidents />,
        permission: "manage_support",
      },
    ],
  },
  // Admin Team – requires manage_team
  {
    path: "/admin-team",
    element: <AdminTeam />,
    permission: "manage_team",
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
        permission: "manage_team",
      },
      { path: "list", element: <AdminList />, permission: "manage_team" },
      { path: "add", element: <AddAdmin />, permission: "manage_team" },
      {
        path: "roles",
        element: <RolesPermissions />,
        permission: "manage_team",
      },
      { path: "activity", element: <ActivityLog />, permission: "manage_team" },
      {
        path: "2fa",
        element: <TwoFactorSettings />,
        permission: "manage_team",
      },
    ],
  },
  // FAQS
  {
    path: "/FAQS_list",
    element: <FAQSList />,
    permission: "manage_support",
  },
  {
    path: "/Add_FAQS",
    element: <Addfaqs />,
    permission: "manage_support",
  },
  {
    path: "/Edit_FAQS",
    element: <Editfaqs />,
    permission: "manage_support",
  },
  {
    path: "/Fees_Structure",
    element: <Feestructure />,
    permission: "manage_finance",
  },
  {
    path: "/Voucher_list",
    element: <VoucherList />,
    permission: "manage_marketing",
  },
  {
    path: "/Add_Voucher",
    element: <AddVoucher />,
    permission: "manage_marketing",
  },
  {
    path: "/Edit_Voucher",
    element: <EditVoucher />,
    permission: "manage_marketing",
  },
  {
    path: "/Push_Notification",
    element: <PushNotification />,
    permission: "manage_marketing",
  },
  {
    path: "/Reports",
    element: <Reports />,
    permission: "view_reports",
  },
  {
    path: "/Settings",
    element: <Settings />,
    permission: "manage_settings",
  },
  {
    path: "/About_Us",
    element: <About />,
    permission: null, // public
  },
  {
    path: "/Privacy_Policy",
    element: <Privacy />,
    permission: null,
  },
  {
    path: "/TermsofService",
    element: <Terms />,
    permission: null,
  },
];

// Now build the routes by wrapping each route with ProtectedRoute
const buildRoutes = (routes) => {
  return routes.map((route) => {
    const { element, children, permission, ...rest } = route;
    // Wrap the element with ProtectedRoute, passing requiredPermission
    const protectedElement = (
      <ProtectedRoute requiredPermission={permission}>{element}</ProtectedRoute>
    );
    // If there are children, recursively build them too
    const protectedChildren = children ? buildRoutes(children) : undefined;
    return {
      ...rest,
      element: protectedElement,
      children: protectedChildren,
    };
  });
};

const MainRoutes = {
  element: <MainLayout />,
  children: buildRoutes(routeConfig),
};

export default MainRoutes;
